<template>
  <div class="focus-list">
    <div class="information focus-item">
      <div class="top">
        <!-- @click="editAvator"  -->
        <div class="avator">
          <img :src="userInfo.avatar || defaultImg" />
          <span>点击图片修改头像</span>
        </div>
        <div class="right_content">
          <div class="first_line">
            <div class="left">
              <span>{{ userInfo.nick_name || userInfo.nick_name }}</span>
              <i class="font_family" style="color: #ff9633; font-size: 30px" @click="editNickName">&#xe660;</i>
            </div>
            <!-- <div class="right" @click="recharge">充值</div> -->
          </div>
          <div class="third_line">
            <!--
            <div class="left">
              <div class="level_item level_item_last">LV3</div>
              <div class="level_progress">
                <div class="level_progress_default">
                  <div class="level_progress_active"></div>
                </div>
              </div>
              <div class="level_item level_item_next">LV4</div>
            </div>
            -->
            <div class="right">
              <div @click="recharge" class="topup_button">充值</div>
            </div>
          </div>
          <div class="second_line">
            <div class="left">
              <div class="account">
                <img src="@/assets/img/user-center/diamonds.png" class="money_icon" />
                <span>
                  <span class="text-des-account">金坷垃</span>
                  : {{ userInfo.diamond }}
                </span>
              </div>
              <!--
              <div class="account-duye">
                <img src="~/assets/img/user-center/ticket.png" class="money_icon" />
                <span>
                  <span class="text-des">鹰钻</span>: 99999999.00
                </span>
              </div>
              -->
            </div>
          </div>
        </div>
      </div>
      <div class="tips">
        <img src="@/assets/img/user-center/flower.png" class="tips_icon" />
        <span>您已加入猎鹰直播88天，平常的日子里，感谢有您相伴~</span>
      </div>
    </div>

    <!-- <div class="information_bottom focus-item"></div> -->
    <!-- 充值弹窗 -->
    <el-dialog title="金坷垃充值" :visible.sync="rechargeDialogVisible" width="663px">
      <el-form ref="form" :model="form" label-width="84px">
        <div class="purchase_list">
          <div class="purchase_text">购买数量：</div>
          <ul>
            <li v-for="item in purchaseQuantity" @click="Cmoney(item)" :key="item.id">
              <div class="top">
                <span class="number">{{ item.number }}</span>
                <span class="text">金坷垃</span>
              </div>
              <div class="bottom">¥{{ item.number }}</div>
            </li>
          </ul>
        </div>
        <el-form-item label="其他金额：" style="margin-top: 10px">
          <el-input v-model="form.name" placeholder="请输入1-99999的整数" style="width: 201px"></el-input>
        </el-form-item>
        <div class="pay_methods common_font_color">支付方式：</div>
        <div class="pay_methods_content">
          <div class="left">
            <ul>
              <li v-for="item in payMethodList" :key="item.id" @click="changeMethods(item.id)" :class="[item.id === payMethodId ? 'active' : '']">
                <img src="https://test-1301875615.cos.ap-beijing.myqcloud.com/images/20211013094041773982020-12-15%2021.33.14.jpg" alt />
                <span>{{ item.name }}</span>
              </li>
            </ul>
          </div>
          <div class="right">
            <img src="https://test-1301875615.cos.ap-beijing.myqcloud.com/images/20211013094041773982020-12-15%2021.33.14.jpg" alt />
            <span>支付宝扫一扫支付</span>
          </div>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer_one" @click="CfirmChanges">
        <div>确认支付</div>
      </div>
    </el-dialog>
    <!-- 头像弹窗 -->
    <el-dialog title="选择头像" :visible.sync="avatorDialogVisible" width="533px" style="height: 432px">
      <ul class="avator_list">
        <li v-for="i in 18" :key="i">
          <img src="https://test-1301875615.cos.ap-beijing.myqcloud.com/images/20211013094041773982020-12-15%2021.33.14.jpg" alt />
        </li>
      </ul>
      <div slot="footer" class="dialog-footer_two">
        <div class="cancle" @click="avatorDialogVisible = false">取消</div>
        <div class="confirm">确认修改</div>
      </div>
    </el-dialog>
    <!-- 修改昵称 -->
    <el-dialog title="昵称修改" :visible.sync="nameChange" width="503px">
      <el-form ref="form" :model="form" :rules="rules">
        <!--
        <div class="special_text">验证将发送到您的手机：187****8765</div>
        <div>
          <div class="name_title">你的改名卡：32张</div>
          <div class="name_title_text">每次修改昵称消耗1张改名卡，并经审核后才能成功</div>
        </div>
        -->
        <div class="Current_name">
          <div>当前昵称：{{ userInfo.nick_name }}</div>
        </div>
        <el-form-item prop="name">
          <el-input v-model="form.name" style="width: 320px" placeholder="请输入您的新昵称"></el-input>
        </el-form-item>
        <el-form-item class="code_last" prop="code">
          <el-input placeholder="请输入验证码" v-model="form.code" style="width: 201px" class="inputtext">
            <i slot="prefix" class="font_family Verification">&#xe651;</i>
          </el-input>
          <div class="send_text" @click="getinfocode">获取验证码</div>
        </el-form-item>
        <el-form-item>
          <div class="dialog_footer" @click="submitNameinfo('form')">
            <div class="confirm submitinfo">确认修改</div>
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { post } from "../../util/http";
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      rechargeDialogVisible: false,
      nameChange: false,
      purchaseQuantity: [
        { id: 1, money: "1金坷垃", number: 1 },
        { id: 2, money: "9金坷垃", number: 9 },
        { id: 3, money: "48金坷垃", number: 48 },
        { id: 4, money: "98金坷垃", number: 98 },
        { id: 5, money: "498金坷垃", number: 498 },
        { id: 6, money: "998金坷垃", number: 998 },
        { id: 7, money: "4988金坷垃", number: 4988 },
        { id: 8, money: "9998金坷垃", number: 9998 },
      ],
      form: {
        name: "",
        code: "",
      },
      namebox: {},
      payMethodList: [
        { name: "支付宝1", id: 1 },
        { name: "支付宝2", id: 2 },
        { name: "支付宝3", id: 3 },
        { name: "支付宝4", id: 4 },
        { name: "支付宝5", id: 5 },
      ],
      payMethodId: 1,
      avatorDialogVisible: false,
      rules: {
        name: [
          { required: true, message: "请输入用户昵称", trigger: "blur" },
          { min: 3, max: 6, message: "长度在 3 到 6 个字符", trigger: "blur" },
        ],
        code: [
          { required: true, message: "请输入验证吗", trigger: "blur" },
          { min: 3, max: 6, message: "长度在 3 到 6 个字符", trigger: "blur" },
        ],
      },
    };
  },
  computed: {
    ...mapState(["userInfo"]),
    defaultImg() {
      return require("./defaultAvatar.png");
    },
  },
  methods: {
    ...mapActions(["getUserInfo"]),
    recharge() {
      this.rechargeDialogVisible = true;
    },
    editNickName() {
      // console.log(33333454444);
      this.nameChange = true;
    },
    Cmoney(i) {
      let { number } = i;
      this.form.name = number;
    },
    // 修改昵称弹窗
    editclick() {
      this.nameChange = !this.nameChange;
    },
    // 提交修改昵称
    submitNameinfo(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let datainfo = {
            nick_name: this.form.name,
          };
          try {
            const {
              data: { data, status },
            } = await post({
              url: "api/user/editUserInfo",
              data: datainfo,
            });
            if (!data & (status == 0)) {
              this.$refs[formName].resetFields();
              this.nameChange = !this.nameChange;
              this.$message({
                message: "昵称修改成功",
                type: "success",
                duration: 2000,
                offset: 120,
              });
              this.getUserInfo();
            }
          } catch (e) {}
        } else {
          return false;
        }
      });
    },
    // 获取验证码
    async getinfocode() {
      let datainfo = {
        mobile: this.userInfo.account,
      };
      try {
        const {
          data: { data, status },
        } = await post({
          url: "api/user/sendVerifyCode",
          data: datainfo,
        });
        if (!data & (status == 0)) {
          this.$message({
            message: "验证码已发送！",
            type: "success",
            duration: 2000,
            offset: 120,
          });
        }
      } catch (e) {}
    },
    // 提交充值金额
    async CfirmChanges() {
      try {
        const {
          data: { data },
        } = await post({
          url: "/api/order/send",
          data: { amount: 0, currency: this.form.name, payment_account_id: 0 },
        });
        console.log(data, "data");
        this.list = data.list;
        this.totalCount = data.count;
      } catch (e) {}
    },
    changeMethods(id) {
      this.payMethodId = id;
    },
    editAvator() {
      this.avatorDialogVisible = true;
    },
  },
};
</script>
<style>

</style>

<style scoped lang="stylus">
	/deep/ {
		// @import "../../assets/modal_common.css";
	}

@import '../../assets/variable.styl';

.avator_list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  li {
    width: 60px;
    margin-bottom: 15px;

    img {
      width: 60px;
      border-radius: 50%;
      cursor: pointer;
    }
  }
}

/deep/ .elmessage {
  top: 100px !important;
}

.text_qx, .special_text {
  height: 42px;
  display: flex;
  align-items: center;
  font-size: 15px;
  color: #1c8c7a;
  justify-content: center;
}

.name_title {
  width: 100%;
  height: 30px;
  font-size: 14px;
  color: #333;
  display: flex;
  align-items: center;
  font-family: PingFangSC;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
}

.name_title_text {
  font-family: PingFangSC;
  height: 30px;
  font-size: 12px;
  color: #999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.Current_name {
  width: 100%;
  height: 40px;
  font-family: PingFangSC;
  font-size: 14px;
  font-weight: 600;
  color: #333;
  display: flex;
  align-items: center;
}

.code_last {
  width: 320px;

  .Verification {
    width: 30px;
    height: 40px;
    font-size: 40px;
    color: #dedede;
  }

  /deep/ .el-input__inner {
    padding-left: 40px;
  }

  /deep/ .el-form-item__content {
    width: 100%;
    display: flex;
  }

  .send_text {
    width: 101px;
    height: 40px;
    border-radius: 3px;
    border: solid 1px #1c8c7a;
    background-color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    color: #1c8c7a;
    box-sizing: border-box;
    cursor: pointer;
    margin-left: 17px;
  }
}

.dialog_footer {
  width: 320px;
  display: flex;
  justify-content: flex-start;
  align-items: center;

  .submitinfo {
    width: 320px !important;
    // background-image: linear-gradient(to right, rgba(255, 255, 255, 0.58), rgba(255, 255, 255, 0.58)), linear-gradient(to right, #58c0ab, #146c7e);
    background-image: linear-gradient(to left, rgba(255, 255, 255, 0.58), rgba(255, 255, 255, 0.58)), linear-gradient(to right, #58c0ab, #146c7e);
    color: #fff;
    font-family: PingFangSC;
    font-stretch: normal;
    font-style: normal;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 28px 0;
    cursor: pointer;
  }
}

/deep/ .el-dialog__body {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.pay_methods_content {
  width: 542px;
  // height: 269px;
  border: solid 1px #d5d5d5;
  background-color: #fff;
  display: flex;
  box-sizing: border-box;
  margin-top: 19px;
  margin-bottom: 20px;

  .left {
    width: 120px;

    ul {
      li {
        box-sizing: border-box;
        list-style: none;
        height: 56px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #999;
        font-size: 14px;
        border-right: 1px solid #d5d5d5;

        img {
          width: 25px;
          height: 24px;
          margin-right: 7px;
        }

        span {
          color: #999;
          font-size: 14px;
        }
      }

      .active {
        border-right: none;
        border-left: 3px solid #1c8c7a;
        border-bottom: 1px solid #d5d5d5;
        border-top: 1px solid #d5d5d5;
        color: #333;
      }

      li:first-child {
        border-top: none;
      }

      li:last-child {
        border-bottom: none;
      }
    }
  }

  .right {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    img {
      width: 152px;
      height: 153px;
    }

    span {
      color: #999;
      font-size: 14px;
    }
  }
}

.purchase_list {
  .purchase_text {
    color: #333;
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 20px;
  }

  ul {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    li {
      display: flex;
      cursor: pointer;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      border: solid 1px #d5d5d5;
      background-color: #fff;
      border-radius: 3px;
      width: 124px;
      height: 66px;
      margin-bottom: 14px;

      .top {
        color: #d9bc88;
        margin-bottom: 6px;
        font-weight: 600;
        display: flex;
        align-items: center;

        .number {
          font-size: 22px;
          margin-right: 3px;
        }

        .text {
          font-size: 14px;
        }
      }

      .bottom {
        font-size: 14px;
        color: #999;
      }
    }

    li:hover {
      box-shadow: 0 0 0 2px #b7d7d2, inset 0 0 0 1px #1c8c7a;
    }
  }
}

.focus-list {
  background: #f9f9f9;
  position: relative;
  min-height: 100%;

  .focus-item {
    background-color: #ffffff;
    box-shadow: 2px 2px 10px 0px rgba(1, 26, 13, 0.1);
  }

  .information {
    padding: 58px 122px 60px 111px;
    height: 240px;
    box-sizing: border-box;

    // display: flex;
    // justify-content: space-between;
    .top {
      display: flex;
      justify-content: space-between;
    }

    .avator {
      position: relative;

      img {
        width: 122px;
        height: 122px;
        background-color: #dddddd;
        border-radius: 3px;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        cursor: pointer;
      }

      span {
        position: absolute;
        bottom: 0px;
        font-size: 12px;
        border-radius: 3px;
        color: #fff;
        height: 20px;
        background-color: #676767;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: normal;
        // font-family: 'PingFangSC-Regular';
        font-family: 'PingFangSC';
        letter-spacing: 0.24px;
      }
    }

    .right_content {
      flex: 1;
      height: 122px;
      margin-left: 22px;

      .first_line {
        display: flex;
        // align-items: center;
        justify-content: space-between;
        align-items: center;

        .left {
          display: flex;
          align-items: center;
          font-size: 14px;
          color: #333;
          font-weight: 600;
          cursor: pointer;
        }

        .right {
        }
      }

      .second_line {
        display: flex;
        margin-top: 26px;
        font-family: 'PingFangSC';

        .left {
          font-size: 14px;
          color: #333;
          display: flex;
          align-items: center;
          width: 341px;

          .text-des {
            display: inline-block;
            width: 44px;
            text-align-last: justify;
          }

          .account {
            flex: 1;
            display: flex;
            align-items: center;

            .text-des-account {
              display: inline-block;
              letter-spacing: 0.28px;
            }
          }

          .account-duye {
            flex: 1;
            display: flex;
            align-items: center;
            padding-left: 18px;
          }

          .money_icon {
            width: 15px;
            height: 15px;
            object-fit: contain;
            margin-right: 5px;
          }
        }
      }

      .third_line {
        display: flex;
        margin-top: 16px;

        .left {
          display: flex;
          align-items: center;
          margin-right: 30px;

          .level_item {
            width: 45px;
            height: 17px;
            text-align: center;
            line-height: 17px;
            color: #fff;
            border-radius: 20px;
            font-size: 12px;
            font-family: 'PingFangSC';
          }

          .level_item_last {
            background-color: #ff9633;
          }

          .level_item_next {
            background-color: #cccccc;
            display: none;
          }

          .level_progress {
            padding: 0 8px;
            width: 161px;
            height: 4px;

            .level_progress_default {
              width: 161px;
              height: 4px;
              background: #cccccc;
              position: relative;
              border-radius: 10px;
              overflow: hidden;
              display: none;
            }

            .level_progress_active {
              position: absolute;
              left: 0;
              top: 0;
              width: 50%;
              height: 4px;
              background-color: #ff9633;
            }
          }
        }

        .right {
          // margin-left: 30px;
          font-family: 'PingFangSC';

          .topup_button {
            width: 60px;
            height: 30px;
            background-color: #fff;
            border-radius: 2px;
            border: solid 1px #d9bc88;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 14px;
            color: #d9bc88;
            cursor: pointer;
          }
        }
      }
    }

    .tips {
      display: flex;
      align-items: center;
      color: #d9bc88;
      font-size: 12px;
      padding-left: 4px;
      padding-top: 23px;
      font-family: 'PingFangSC';
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: 0.24px;

      .tips_icon {
        width: 15px;
        height: 15px;
        object-fit: contain;
        margin-right: 2px;
      }
    }
  }

  .information_bottom {
    margin-top: 29px;
    height: 665px;
  }
}
</style>
